'use client';
import PropTypes from 'prop-types';
// material
import { Autocomplete, Box, IconButton, TextField, Typography } from '@mui/material';

// import { useRouter } from 'next/navigation';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
// ----------------------------------------------------------------------

BreadCrumb.propTypes = {
    action: PropTypes.node,
    links: PropTypes.array,
    sx: PropTypes.object
};

export default function BreadCrumb({ action, isBack = false, leftContent, links = [], sx, ...other }) {
    const navigate = useNavigate();
    const handleNavigation = (link = null) => {
        if (link) {
            navigate(link)
        } else {
            navigate(-1)
        }
    }
    return (
        <Box sx={{ mb: 1, ...sx }} {...other}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ flexGrow: 1, display: "flex", alignItems: "start" }}>
                    {(links?.length > 1 || isBack) &&
                        <IconButton size='small'
                            onClick={() => handleNavigation(null)}
                        >
                            <ArrowBackIcon fontSize='small' />
                        </IconButton>
                    }
                    {
                        links.map((item, i) => <Typography
                            key={item?.name}
                            sx={{ cursor: item?.link ? "pointer" : "text" }}
                            onClick={() => item?.link && handleNavigation(item?.link)}
                            variant={links?.length === 1 ? "h5" : "h6"}
                            color="text.secondary.lighter">
                            {item?.name}{(links.length - 1 > i ? "/" : "")}
                        </Typography>)
                    }

                    {leftContent}
                </Box>

                {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
            </Box>
        </Box>
    );
}
